export default [
  {
    title: "Report",
    customIcon: "ReportSVG",
    children: [
      {
        title: "Report List",
        route: "custom-report",
        path: "/custom-report",
      }
    ],
  },
];